import { render, staticRenderFns } from "./VeRing.vue?vue&type=template&id=92fd8476&scoped=true&"
import script from "./VeRing.vue?vue&type=script&lang=js&"
export * from "./VeRing.vue?vue&type=script&lang=js&"
import style0 from "./VeRing.vue?vue&type=style&index=0&id=92fd8476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fd8476",
  null
  
)

export default component.exports